<template>
  <div class="relative has-mega">
    <button class="nav-link">
      {{ label }}
      <svg class="w-3 h-3" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="6 9 12 15 18 9"/></svg>
    </button>
    <div class="mega absolute top-full left-1/2 -translate-x-1/2 mt-2.5 z-50 min-w-[560px] surface rounded-2xl p-3 grid grid-cols-2 gap-1">
      <router-link
        v-for="item in items" :key="item.to" :to="item.to"
        class="mega-item flex gap-2.5 p-2.5 rounded-xl transition-colors hover:bg-white/[.05]"
      >
        <div class="w-8 h-8 rounded-lg grid place-items-center shrink-0" :class="iconClass(item.tone)">
          <slot :name="`icon-${item.to}`">
            <svg class="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/></svg>
          </slot>
        </div>
        <div>
          <div class="text-sm font-semibold text-ink">{{ item.label }}</div>
          <div class="text-xs text-muted">{{ item.hint }}</div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script setup>
defineProps({
  label: { type: String, required: true },
  items: { type: Array, required: true },
});

function iconClass(tone) {
  return tone === 'purple'
    ? 'bg-purple/10 text-purple-light border border-purple/25'
    : 'bg-cyan/10 text-cyan-light border border-cyan/25';
}
</script>

<style scoped>
.nav-link {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 8px 12px; border-radius: 10px;
  color: var(--ink-2); font-size: 14px; font-weight: 500;
  transition: all .15s ease;
}
.nav-link:hover { color: var(--ink); background: rgba(255,255,255,.04); }
.mega {
  opacity: 0; visibility: hidden;
  transform: translateX(-50%) translateY(8px);
  transition: opacity .2s ease, transform .2s ease, visibility 0s linear .2s;
  background: var(--surface-2);
}
.has-mega:hover .mega {
  opacity: 1; visibility: visible;
  transform: translateX(-50%) translateY(0);
  transition: opacity .2s ease, transform .2s ease, visibility 0s linear 0s;
}
</style>
